/**
 * Creates a deep copy of the input object.
 *
 * @param object - The object to be cloned.
 * @returns The cloned object.
 */
export default function deepClone<T>(object: T): T {
  return JSON.parse(JSON.stringify(object))
}
